import React from 'react';
import Helmet from 'react-helmet';
import { connect } from '../../connect';
import { amplitudeLogEvent } from '../../helpers/amplitude-helper';
import { CompactItemList } from '../../components/compact-item-list';
import { LoadingIndicator } from '../../components/loading-indicator';
import { NotFound } from '../../components/not-found';
import { SmallSubscribeBanner } from '../../components/small-subscribe-banner';
import { getTopItemsInCategories } from '../../actions';
import logger from '../../utils/logger';
import baseUrls from '../../data/baseUrls';
import { categoryLandingPages } from '../../data/landingPages';
import './index.less';
import { ISubscriptionState } from '../../reducers/subscription-reducers';
import { ITopItemsState } from '../../reducers/top-items-reducers';

function mapStateToProps({ topItems, auth, subscription }, ownProps) {
	const token = ownProps.location.pathname.substr(1);
	return { topItems, auth, subscription, token };
}

interface ICategoryLandingPageProps {
	topItems: ITopItemsState;
	token: string;
	subscription: ISubscriptionState;
}

@connect(mapStateToProps)
export default class CategoryLandingPage extends React.Component<ICategoryLandingPageProps> {
	static activate(store, { location }) {
		const token = location.pathname.substr(1);
		const landingPage = categoryLandingPages.find(x => x.token === token);
		const categoryIds = landingPage && landingPage.categoryIds;
		return store.dispatch(getTopItemsInCategories(categoryIds)).catch(logger.error);
	}

	componentDidMount() {
		amplitudeLogEvent('Category Landing - Viewed', { Token: this.props.token });
	}

	render() {
		const {
			subscription,
			topItems: { isFetching, items },
			token,
		} = this.props;
		const landingPage = categoryLandingPages.find(x => x.token === token);
		const bannerTitle = landingPage && landingPage.bannerTitle;
		const bannerSubtitle = landingPage && landingPage.bannerSubtitle;
		const title = landingPage && (landingPage.title || bannerTitle);
		const description = landingPage && (landingPage.description || bannerSubtitle);
		const imageUrl =
			landingPage && (landingPage.imageUrl || `${baseUrls.faithlifeTv}/public/images/faithlife-tv-550x312.png`);
		const shouldIndex = landingPage && (typeof landingPage.shouldIndex !== 'boolean' ? true : landingPage.shouldIndex);

		const meta = [
			{ property: 'og:title', content: `${title} - Faithlife TV` },
			{ property: 'og:image', content: imageUrl },
			{ property: 'og:type', content: 'website' },
			{ property: 'og:description', content: description },
			{ name: 'description', content: description },
			{ property: 'twitter:site', content: '@faithlife' },
			{ property: 'twitter:card', content: 'summary_large_image' },
			{ property: 'twitter:title', content: `${title} - Faithlife TV` },
			{ property: 'twitter:description', content: description },
			{ property: 'twitter:image', content: imageUrl },
		];

		return (
			<div className="category-landing-page">
				<Helmet
					title={bannerTitle}
					meta={!shouldIndex ? [...meta, { name: 'robots', content: 'noindex, nofollow' }] : meta}
				/>
				<SmallSubscribeBanner title={bannerTitle} subtitle={bannerSubtitle} buttonUrl="/" buttonLabel="See More" />
				{isFetching ? (
					<LoadingIndicator />
				) : !items ? (
					<NotFound />
				) : (
					<div className="content">
						<CompactItemList items={items} imageHeight={170} subscription={subscription} />
					</div>
				)}
			</div>
		);
	}
}
